import { api } from 'api'
import { createAsyncThunk } from 'modules/store'

export const getAllGranularities = createAsyncThunk('users/getAllGranularities', async (_, { rejectWithValue }) =>
  api.granularities.getAll().catch((error) => rejectWithValue(error.message)),
)
